import {Component, signal} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EmojiTrail } from './components/emoji-trail/emoji-trail';
import { Preloader } from './components/preloader/preloader';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    EmojiTrail,
    Preloader,
    NgIf
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  showPreloader = signal(true);

  hidePreloader(): void {
    this.showPreloader.set(false);
  }
}
